import { RangePicker, Select } from '@lmc/ui-kit'
import type dayjs from 'dayjs'
import type { RangeValue } from 'types/shared'

export enum FiltersInputType {
  DateRange = 'DATE_RANGE',
  Select = 'SELECT'
}

export type InputItemType = {
  type: FiltersInputType
  value?: unknown
  onChange?: (value: unknown, other: unknown) => void
  placeholder?: string | [string, string]
  format?: string
  options?: object[]
}

export const getInputType = (item: InputItemType) => {
  switch (item.type) {
    case FiltersInputType.DateRange:
      return (
        <RangePicker
          style={{ width: 'fit-content' }}
          placeholder={item.placeholder as [string, string]}
          value={item.value as RangeValue<dayjs.Dayjs>}
          onChange={item.onChange}
          format={item.format}
          allowClear
          data-cy="range-picker"
        />
      )
    case FiltersInputType.Select:
      return (
        <Select
          placeholder={item.placeholder}
          style={{ width: 'fit-content', minWidth: '130px', marginLeft: 12 }}
          value={item.value}
          onChange={item.onChange}
          options={item.options}
          allowClear
          data-cy="select"
        />
      )
    default:
      return null
  }
}
